/* unplugin-vue-components disabled */import { render } from "./DocEditor.vue?vue&type=template&id=c4d87c34&scoped=true"
import script from "./DocEditor.vue?vue&type=script&lang=js"
export * from "./DocEditor.vue?vue&type=script&lang=js"

import "./DocEditor.vue?vue&type=style&index=0&id=c4d87c34&lang=less&scoped=true"
import "./DocEditor.vue?vue&type=style&index=1&id=c4d87c34&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d87c34"]])

export default __exports__